import { Process } from "../models/lmf.models";

export const validateTimeField = (
  value: Date | null,
  fieldName: string,
  process: Process | undefined,
): string | true => {
  if (!value) return true;

  const timeValue = new Date(value);

  switch (fieldName) {
    case "Start":
      if (process?.Start && timeValue < new Date(process.Start)) {
        return "Arrive time must be after process' Start time";
      }
      if (process?.End && timeValue > new Date(process.End)) {
        return "Arrive time must be before End time";
      }
      break;

    case "End":
      if (process?.End && timeValue < new Date(process.End)) {
        return "Ship time must be after Arrive time";
      }
      break;
  }

  return true;
};

export const validateDurationAgainstProcess = (
  valueInSeconds: number | null,
  process: Process | undefined,
  fieldLabel = "Duration",
): string | true => {
  if (valueInSeconds === null || process === undefined) return true;

  const minutes = valueInSeconds / 60;

  if (process.End != null && process.ProcessTime != null) {
    if (minutes > process.ProcessTime) {
      return `${fieldLabel} cannot exceed Treatment Duration`;
    }
  } else if (process.Start != null) {
    const now = new Date();
    const elapsedMinutes =
      (now.getTime() - new Date(process.Start).getTime()) / (1000 * 60);
    if (minutes > elapsedMinutes) {
      return `${fieldLabel} cannot exceed elapsed process time`;
    }
  }

  return true;
};

export const validatePlugValues = (
  value: number | null,
  process: Process | undefined,
): string | true => {
  if (value === null || process === undefined) return true;

  if (value >= 10000) {
    return "Value must be less than 10000";
  }

  return true;
};
